const InitAccordionSameHeightElements = (accordionClass, elementClass) => {
    const accordionElement = document.querySelector('.accordion');
    if (!accordionElement || accordionElement.getAttribute('id') === 'noEqualHeight') {
        return;
    }

    const accordionItems = document.querySelectorAll(accordionClass);
    let maxHeight = 0;

    accordionItems.forEach((acc) => {
        if (!acc.classList.contains('show')) return;

        let contactCards = acc.querySelectorAll(elementClass);
        maxHeight = getMaxHeight(contactCards);

        contactCards.forEach((card) => {
            card.style.height = maxHeight + 'px';
        });
    });

    accordionItems.forEach((acc) => {
        acc.addEventListener('click', () => {
            let contactCards = acc.querySelectorAll(elementClass);
            let maxHeight = 0;

            contactCards.forEach((card) => {
                card.style.height = "auto";

                if (card.offsetHeight > maxHeight) {
                    maxHeight = card.offsetHeight;
                    if (card.querySelector('picture'))
                        maxHeight = card.offsetHeight + 250; // 250px is the height of the image
                }
            });

            contactCards.forEach((card) => {
                card.style.height = maxHeight + 'px';
            });
        });
    });
};

InitAccordionSameHeightElements(".accordion-item", ".contact-teaser");

const getMaxHeight = (contactCards) => {
    let maxHeight = 0;

    contactCards.forEach((card) => {
        if (card.offsetHeight > maxHeight) {
            maxHeight = card.offsetHeight;
        }
    });

    return maxHeight;
}
